import axios from '_u/axios'

/**
 * 维修表查询列表
 * @param body
 */
export const repairList = (body) => {
    return axios.post('api/daily/repair/list', body)
}

/**
 * 维修表查看明细
 * @param id
 */
export const repairView = (id) => {
    return axios.post('api/daily/repair/view', { id })
}
/**
 * 取消维修
 * @param body
 */
export const repairCancel = (body) => {
    return axios.post('api/daily/repair/cancel', body)
}
/**
 * 接收维修工单
 * @param id
 */
export const repairReceive = (id) => {
    return axios.post('api/daily/repair/receive', { id })
}
/**
 * 新增维修费用
 * @param body
 */
export const repairAddFee = (body) => {
    return axios.post('api/daily/repair/addFee', body)
}
/**
 * 新增反馈进度
 * @param body
 */
export const repairFeedBack = (body) => {
    return axios.post('api/daily/repair/feedBack', body)
}
/**
 * 查看点评
 * @param body
 */
export const repairViewAssess = (body) => {
    return axios.post('api/daily/repair/viewAssess', body)
}
/**
 * 查看反馈进度
 * @param id
 */
export const repairViewFeedBack = (id) => {
    return axios.post('api/daily/repair/viewFeedBack', { id })
}
/**
 * 查看维修费用
 * @param body
 * @returns {*}
 */
export const repairViewFee = (body) => {
    return axios.post('api/daily/repair/viewFee', body)
}

/**
 * 查看维修费用
 * @param body
 * @returns {*}
 */
export const repairAdd = (body) => {
    return axios.post('api/daily/repair/add', body)
}
/**
 * 提交点评
 * @param body
 */
export const repairAssess = (body) => {
    return axios.post('api/daily/repair/assess', body)
}


/**
 * PC新增维修
 */
export const addRepairForPc = (body) => {
    return axios.post('api/daily/repair/addRepairForPc', body)
}